import {ApplicationConfig} from '#core/config/application-config.js';

export function isSentryReportingAllowed() {
    if (!window.location.pathname.startsWith(ApplicationConfig.initParams.routingPrefix)) {
        return false;
    }
    if (/(openRegistrationPage)/.test(window.location.search)) {
        return false;
    }
    return true;
}
